import React from "react";
import { HandHeartIcon, LightbulbIcon, ListOrderedIcon, MessagesSquareIcon, QuoteIcon, TimerIcon, BoxIcon } from "lucide-react";
import { features } from "../data/content";
import { SectionHeading } from "./SectionHeading";
const icons: Record<(typeof features.items)[number]['icon'], BoxIcon> = {
  idea: LightbulbIcon,
  outline: ListOrderedIcon,
  hook: QuoteIcon,
  timer: TimerIcon,
  prayer: HandHeartIcon,
  group: MessagesSquareIcon
};
export function FeaturesSection() {
  return <section aria-labelledby="features-title" className="bg-cream py-12 md:py-20" data-id="element-45" data-mp="1m8xxs57x4zwn">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-46" data-mp="2002oghtb6huu">
        <SectionHeading id="features-title" title={features.title} sub={features.sub} data-id="element-47" data-mp="200vwrn7x1ff3" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:gap-4 lg:grid-cols-3" data-id="element-48" data-mp="1v8b5otge9gf9">
          {features.items.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4 rounded-xl border border-cream-line bg-white p-5 md:p-6" data-id="element-49" data-mp="13ipvfpc1mdhi">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-teal-tint text-teal" data-id="element-50" data-mp="31ae8vaymrqif">
                  <Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-51" data-mp="368xrb1e0mk61" />
                </span>
                <div data-id="element-52" data-mp="3b20pxnxngjt3">
                  <h3 className="font-display text-[16px] font-extrabold uppercase leading-snug tracking-tight text-teal" data-id="element-53" data-mp="3b3lbio1zkset">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-ink/75" data-id="element-54" data-mp="2ieeb1jiz1sqx">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}